<template>
  <div>
    <vue-headful :title="`Agreement - ${inspectionStreetAddress} ${inspectionLocation}`" />
    <AgreementsLoader v-if="apiLoading" />
    <div v-if="apiLoaded" class="agreement">
      <hg-address-title-bar
        :hg-address="inspectionStreetAddress"
        :hg-location="inspectionLocation"
        :hg-logo="company.logo"
        class="title">
        <hg-inspection-button :hg-folder-id="folderId" />
      </hg-address-title-bar>
      <v-layout>
        <v-flex xs12 md8 offset-md2>
          <v-flex xs12>
            <hg-form-header :companyEmail="company.email" :companyPhone="company.phone" />
          </v-flex>
          <v-flex>
            <hg-form
              :agreements="agreements"
              :folderId="folderId"
              @saved="redirectToInspectionDetails" />
          </v-flex>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import BaseViewComponent from '@/components/Shared/BaseViewComponent.vue';
import AgreementsLoader from '@/components/Loaders/AgreementsLoader.vue';
import AddressTitleBar from '../AddressBar/AddressTitleBar.vue';
import Form from '../Agreement/Form.vue';
import FormHeader from '../Agreement/FormHeader.vue';
import InspectionButton from '../AddressBar/InspectionButton.vue';

export default {
  extends: BaseViewComponent,
  components: {
    'hg-address-title-bar': AddressTitleBar,
    'hg-form-header': FormHeader,
    'hg-form': Form,
    'hg-inspection-button': InspectionButton,
    AgreementsLoader,
  },
  mounted() {
    this.initialHydration([
      this.$store.dispatch('Folders/loadAgreements', this.folderId),
      this.$store.dispatch('Inspection/loadInspection', this.folderId),
      this.$store.dispatch('Company/loadCompany', this.companyId),
    ]);
  },
  props: {
    companyId: {
      type: String,
      required: true,
    },
    folderId: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters('Inspection', [
      'inspectionStreetAddress',
      'inspectionLocation',
    ]),
    ...mapState('Company', {
      company: state => state.company,
    }),
    ...mapState('Folders', {
      agreements: state => state.agreements,
    }),
  },
  methods: {
    redirectToInspectionDetails(agrees) {
      const agreements = agrees || [];

      this.$router.push({
        name: 'inspection',
        params: {
          folderId: this.folderId,
          hgShowAgreementsSuccess: agreements.filter(agreement => agreement.status === 'SIGNED').length > 0,
          hgShowAgreementsWarning: agreements.filter(agreement => agreement.status === 'DECLINED').length > 0,
        },
      });
    },
  },
};
</script>
